import { render, staticRenderFns } from "./index-left.vue?vue&type=template&id=6f891869&scoped=true"
import script from "./index-left.vue?vue&type=script&lang=js"
export * from "./index-left.vue?vue&type=script&lang=js"
import style0 from "./index-left.vue?vue&type=style&index=0&id=6f891869&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f891869",
  null
  
)

export default component.exports